module.exports = __webpack_public_path__ + "static/groenhuysen-7cc1126768512d0261e83ac9bbc6c593.png";